import { createAsyncThunk } from '@reduxjs/toolkit';
import { isNotDefined } from '@sgme/fp';

import { helpRequestApi, type SendHelpRequestRequest } from '@/api/help-request/sendHelpRequest.ts';
import { logger } from '@/components/SgwtBootstrap/logger.ts';

type Outcome = 'succeed' | 'failed"';

export const sendHelpRequestThunk = createAsyncThunk<Outcome, SendHelpRequestRequest>(
  'helpRequest/sendHelpRequest',
  async (params, { dispatch }) => {
    const request = helpRequestApi.endpoints.sendHelpRequest.initiate(params);
    return dispatch(request)
      .unwrap()
      .then(() => 'succeed' as Outcome)
      .catch((error) => {
        logger.logError('Error while sending help request {message_s}', error.message);

        if (isNotDefined(params.screenshot) || error.status !== 413) {
          return 'failed' as Outcome;
        }

        const request2 = helpRequestApi.endpoints.sendHelpRequest.initiate({
          ...params,
          screenshot: undefined,
          details: `[state and screenshot missing because of error 413, screenshot size was ${params.screenshot?.length}]\n\n${params.details || ''}`,
        });

        return dispatch(request2)
          .unwrap()
          .then(() => 'succeed' as Outcome)
          .catch((error2) => {
            logger.logError('Error while sending help request {message_s}', error2.message);
            return 'failed' as Outcome;
          });
      });
  },
);
